import React from 'react'
import { makeStyles, createStyles, Box } from '@material-ui/core'
import { MOBILE_HEADER_HEIGHT } from 'src/mobile/utils/constant'
import classnames from 'classnames'
import HeaderTop from 'src/mobile/components/Homepage/Header'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      height: theme.spacing(MOBILE_HEADER_HEIGHT),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: ({ bg }) => (bg ? bg : theme.palette.background.paper),
      position: 'sticky',
      top: 0,
      zIndex: theme.zIndex.appBar,
    },
    fixed: {
      position: 'fixed',
    },
  }),
)

const Header = ({ header }) => {
  const classes = useStyles({ bg: header?.backgroundColor })
  return header ? (
    <Box
      className={classnames(classes.root, {
        [classes.fixed]: header?.fixed,
      })}
    >
      <HeaderTop />
    </Box>
  ) : null
}

export default Header
